import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProductEloquaCategory } from '../../../contact/models/product-category-eloqua.model';

@Component({
  selector: 'app-product-category-selector',
  templateUrl: './product-category-selector.component.html',
  standalone: false,
})
export class ProductCategorySelectorComponent {
  @Input() formGroup: FormGroup;
  @Input() hasProductCategory = false;
  @Input() productCategories: ProductEloquaCategory[] = [];
  @Input() labelKey = 'SERVICEPOINT.CONTACT.PRODUCTCATEGORY';
}
